import { zergApi } from "@/service/zerg";

// export const storeSections = async (sections) => {
//   const request = indexedDB.open("zergdb");

//   request.onerror = (event) => {
//     console.error("Why didn't you allow my web app to use IndexedDB?!");
//     console.log(event);
//   };

//   request.onsuccess = (event) => {
//     console.log("onsuccess");
//     const db = event.target.result;

//     if (!db.objectStoreNames.contains("sections")) {
//       const objectStore = db.createObjectStore("sections", {
//         keyPath: "section_id",
//       });
//       objectStore.createIndex("section_id", "section_id", { unique: true });
//     } else {
//       const transaction = db.transaction("sections", "readwrite");
//       const objectStore = transaction.objectStore("sections");
//       sections.forEach((section) => {
//         objectStore.add(section);
//       });
//     }

//     db.close();
//   };

//   request.onupgradeneeded = (event) => {
//     const db = event.target.result;

//     const objectStore = db.createObjectStore("sections", {
//       keyPath: "section_id",
//     });

//     objectStore.createIndex("section_id", "section_id", { unique: true });
//     // db.close();
//   };
// };



export const storeSections = async (sections) => {
  const request = indexedDB.open("zergdb");

  request.onerror = (event) => {
    console.error("Why didn't you allow my web app to use IndexedDB?!");
    console.log(event);
  };

  request.onsuccess = (event) => {
    const db = event.target.result;

    const transaction = db.transaction("sections", "readwrite");
    const objectStore = transaction.objectStore("sections");

    transaction.oncomplete = () => {
      db.close();
    };

    sections.forEach((module) => {
      objectStore.put(module);
    });
  };

  request.onupgradeneeded = (event) => {
    const db = event.target.result;

    const objectStore = db.createObjectStore("sections", {
      keyPath: "section_id",
    });

    objectStore.createIndex("section_id", "section_id", { unique: true });
    db.close();
  };

  return true;
};

export const storeSectionsInLocalStorage = (sections) => {
  localStorage.setItem("sections", JSON.stringify(sections));
  if (localStorage.getItem("sections")) {
    return true;
  }
  return false;
}

export const fetchNewRoutes = async () => {
  try {
    const email = JSON.parse(localStorage.getItem("userData")).email;
    const oldRoutes = JSON.parse(localStorage.getItem("userData"));
    const { data } = await zergApi.get("/user/get-user-for-email/" + email);
    oldRoutes.arr_modules = data.arr_modules;
    oldRoutes.arr_sections = data.arr_sections;
    localStorage.setItem("userData", JSON.stringify(oldRoutes));
  } catch (error) {
    console.log(error);
  }
}